import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import {
  SortableList, SortableListRow, keyOf, reorderById, reorderInState, withDndSensors,
} from './shared/dndSortable';
import { newColumn, processInitialColumns } from './shared/columnFields';
import Column from './customUrlColumns/Column';

export { reorderById };

class CustomUrlColumnFields extends React.Component {
  static propTypes = {
    initialCustomUrlColumns: PropTypes.array,
    availableColumns: PropTypes.array.isRequired,
    disabled: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      availableColumns: processInitialColumns(this.props.availableColumns, this.columnId),
      customUrlColumns: processInitialColumns(this.props.initialCustomUrlColumns, this.columnId),
    };
  }

  columnId = (column) => `${column.columnType}-${column.name}`;

  onDragEnd = (event) => reorderInState(event, this, 'customUrlColumns');

  handleNameChange = (index, value) => {
    const validColumn = this.state.availableColumns.find((column) => column.id === value);
    if (validColumn) {
      const newColumns = update(this.state.customUrlColumns, {
        [index]: {
          id: { $set: validColumn.id },
          columnType: { $set: validColumn.columnType },
          name: { $set: validColumn.name },
          header: { $set: validColumn.header },
        },
      });
      this.setState({ customUrlColumns: newColumns });
    }
  };

  handleHeaderChange = (index, value) => {
    const newColumns = update(this.state.customUrlColumns, {
      [index]: { header: { $set: value } },
    });
    this.setState({ customUrlColumns: newColumns });
  };

  handleColumnRemove = (index) => {
    const newColumns = update(this.state.customUrlColumns, { $splice: [[index, 1]] });
    this.setState({ customUrlColumns: newColumns });
  };

  handleAddColumn = () => {
    const newColumns = update(this.state.customUrlColumns, { $push: [newColumn()] });
    this.setState({ customUrlColumns: newColumns });
  };

  render() {
    const itemIds = this.state.customUrlColumns.map(keyOf);

    let urlColumnsNode;
    if (this.state.customUrlColumns.length < 1) {
      urlColumnsNode = (
        <input
          type="hidden"
          name="project[custom_url_columns][0][column_type]"
          value="default"
        />
      );
    } else {
      urlColumnsNode = (
        <div>
          <div className="row mb-10">
            <div className="col-xs-1 col-drag-handle"></div>
            <div className="col-xs-5">
              <div className="text-semibold">Column Value</div>
            </div>
            <div className="col-xs-5">
              <div className="text-semibold">Column Heading</div>
            </div>
            <div className="col-xs-1"></div>
          </div>

          <SortableList sensors={this.props.__sensors} items={itemIds} onDragEnd={this.onDragEnd}>
            {this.state.customUrlColumns.map((column, index) => (
              <SortableListRow key={column.key} id={keyOf(column)}>
                <Column
                  index={index}
                  column={column}
                  baseInputName="project[custom_url_columns]"
                  availableColumns={this.state.availableColumns}
                  handleNameChange={this.handleNameChange}
                  handleHeaderChange={this.handleHeaderChange}
                  onRemove={this.handleColumnRemove}
                  inputDisabled={this.props.disabled}
                />
              </SortableListRow>
            ))}
          </SortableList>
        </div>
      );
    }

    let addColumnNode = null;
    if (!this.props.disabled) {
      addColumnNode = (
        <div className="row">
          <div className="col-xs-1 col-drag-handle"></div>
          <div className="col-xs-11">
            <a onClick={this.handleAddColumn}>
              <i className="icon-plus22 position-left"></i>
              Add column
            </a>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="form-group">
          <div className="col-xs-12">
            {urlColumnsNode}
            {addColumnNode}
          </div>
        </div>
      </div>
    );
  }
}

export default withDndSensors(CustomUrlColumnFields);
